import { renderDateOfDeathCell } from '@/pages/decedent-list/row/renderDateOfDeath';
import { renderFullNameCell } from '@/common/components/DataGridTable/row/renderFullNameCell';

export const getDecedentListColumns = (t) => [
  {
    field: 'firstName',
    headerName: t('Decedent’s name'),
    flex: 1.6,
    minWidth: 280,
    sortable: false,
    renderCell: renderFullNameCell(({ row }) => row),
  },
  {
    field: 'dateOfDeath',
    headerName: t('Date of death'),
    flex: 1,
    minWidth: 180,
    sortable: false,
    renderCell: renderDateOfDeathCell,
  },
  {
    field: 'primaryUser',
    headerName: t('Primary Account User'),
    flex: 1,
    minWidth: 240,
    sortable: false,
    renderCell: renderFullNameCell(),
  },
];
